import SodUserChip from './SodUserChip';
export default SodUserChip;
